












































































































































































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import GenericBTable from "@/core/Generics/GenericBTable";
import Annoucement from "@/models/porposal/porposal.model";
import { BTableColumnType } from "@/enums/BTableColumnType";
import AnnoucementService from "@/services/porposal.service";
import { PermissionValue } from "@/enums/PermissionValue";
import { RowTable } from "@/typings/BRowTable";
import BTableColumn from "@/models/base/BTableColumn.model";
import { ProposalState } from "@/enums/ProposalState";
import ResearchCenterBasicInformationComponent from "@/components/research-center-basic-information/researchCenterBasicInformation.vue";
import fileService from "@/services/file.service";
import ProposalUserReport from "../../models/porposal/porposalUserReport.model";
import PorposalService from "@/services/porposal.service";

@Component({
  components: {
    ResearchCenterBasicInformationComponent
  }
})
export default class UserReportTableComponent extends GenericBTable<
  Annoucement
> {
  @Prop() public refreshTable!: number;
  @Prop() public estado!: ProposalState;
  @Prop() public isFondocyt!: boolean;

  code: string = "";
  codes: string = "";
  budgetExecuted: number = 0;
  budgetNotExecuted: number = 0;
  annoucementId: number = null;
  motivoDevolucion: string = "";
  proposalUserReportModel: any = null;
  isLoading: boolean = false;
  isComponentModalActive: boolean = false;
  showBudgetModal: boolean = false;

  enviadoCI: ProposalState = ProposalState.EnviadoCI;
  devueltoCI: ProposalState = ProposalState.DevueltoCI;
  enviadoFC: ProposalState = ProposalState.EnviadoFC;
  devueltoFC: ProposalState = ProposalState.DevueltoFC;

  proposalService: PorposalService = new PorposalService();

  created() {
    this.tableConfig.controller = `PorposalUserReport/GetReportsByEstado/${this.estado}`;
    this.tableConfig.rowClass = (row: ProposalUserReport, index: number) =>
      row.projectEndDocument && "is-primary-mescyt";
    this.formatColumns();
  }

  setModel(data: any) {
    this.proposalUserReportModel = data;
    this.isComponentModalActive = true;
  }

  setBudgetModal(data: any) {
    this.proposalUserReportModel = data;
    this.budgetExecuted = this.proposalUserReportModel.budgetExecuted;
    this.budgetNotExecuted = this.proposalUserReportModel.budgetNotExecuted;
    this.showBudgetModal = true;
  }

  async addBudgets() {
    if (this.budgetExecuted > 0) {
      this.isLoading = true;
      this.proposalUserReportModel.budgetExecuted = this.budgetExecuted;
      this.proposalUserReportModel.budgetNotExecuted = this.budgetNotExecuted;
      await this.proposalService.addBugetsToProposal(
        this.proposalUserReportModel.id,
        this.proposalUserReportModel
      );
      this.isLoading = false;
      this.showBudgetModal = false;
      this.operationSuccess(
        "Se ha agregado los presupuestos de manera exitosa"
      );
      this.$emit("refreshTable", true);
      this.cleanModel();
    } else {
      this.operationNoAllowed("Debe ingresar los presupuestos");
    }
  }

  formatColumns() {
    let name = new BTableColumn("name", "table.project", true);
   
    //let date = new BTableColumn("createdDate","table.createdDate",true);
    let researchCenter = new BTableColumn(
      "researchCenter",
      "table.researchCenter",
      true
    );

    researchCenter.customTemplate = true;
    name.customTemplate = true;
    name.width = "35%";
    researchCenter.width = "30%";
    //date.type = BTableColumnType.DateTime;

    if (this.estado == this.devueltoCI || this.estado == this.devueltoFC) {
      let reason = new BTableColumn("reason", "table.reason", true);
      reason.customTemplate = true;
      this.tableConfig.insertColumns(name, researchCenter, reason);
    } else {
      this.tableConfig.insertColumns(name, researchCenter);
    }

    this.tableConfig.actions.customTemplate = true;
    this.tableConfig.enableDefaultColumns = false;
  }

  @Watch("annoucementId")
  getByAnnoucement() {
    this.tableConfig.whereParams = `Proposal/AnnoucementId eq ${this.annoucementId}`;
    this.tableConfig.reload();
  }

  @Watch("code")
  getByCode() {
    this.tableConfig.whereParams = `contains(Proposal/Code, '${this.code}')`;
    this.tableConfig.reload();
  }

  @Watch("refreshTable")
  onrefreshTable(value: number) {
    if (value > 0) {
      this.tableConfig.reload();
    }
  }

  searchByCode(event: any) {
    if (event.keyCode === 13) {
      this.code = this.codes.trim();
    }
  }
  watchReport(row: ProposalUserReport) {
    this.$router.push("/proyecto/reporte/" + row.id);
  }
  // async verDocument(data: any = null) {
  //   if (data.isLastResport) {
  //     if (data.document.contentType == "application/octet-stream")
  //       await fileService.downloadOctetFile(
  //         data.document.id,
  //         data.document.originalName
  //       );
  //     else await fileService.download(data.document.id);
  //     //
  //     if (data.projectEndDocument.contentType == "application/octet-stream")
  //       await fileService.downloadOctetFile(
  //         data.projectEndDocument.id,
  //         data.projectEndDocument.originalName
  //       );
  //     else await fileService.download(data.projectEndDocument.id);
  //   } else {
  //     if (data.document.contentType == "application/octet-stream")
  //       await fileService.downloadOctetFile(
  //         data.document.id,
  //         data.document.originalName
  //       );
  //     else await fileService.download(data.document.id);
  //   }
  // }

  async sendReportToFondocyt(data: any) {
    this.isLoading = true;
    data.state = ProposalState.EnviadoFC;
    data.reason = null;
    await this.proposalService.updateProposalUserReport(data.id, data);
    this.isLoading = false;
    this.operationSuccess("Se ha enviado el informe de manera exitosa");
    this.$emit("refreshTable", true);
  }

  async confirmReturn() {
    if (this.motivoDevolucion && this.motivoDevolucion != "") {
      this.isComponentModalActive = false;
      this.proposalUserReportModel.state = this.isFondocyt
        ? ProposalState.DevueltoFC
        : ProposalState.DevueltoCI;
      this.proposalUserReportModel.reason = this.motivoDevolucion;
      await this.proposalService.updateProposalUserReport(
        this.proposalUserReportModel.id,
        this.proposalUserReportModel
      );
      this.operationSuccess("Se ha devuelto el informe de manera exitosa");
      this.$emit("refreshTable", true);
      this.cleanModel();
    } else {
      this.$buefy.toast.open({
        message: "Debe escribir un motivo.",
        type: "is-warning",
        duration: 2000
      });
    }
  }

  cleanModel() {
    this.proposalUserReportModel = null;
    this.motivoDevolucion = null;
    this.budgetExecuted = 0;
    this.budgetNotExecuted = 0;
  }

  showRazonUltimoMovimiento(movimientos: any[]) {
    return movimientos[movimientos.length - 1].razon;
  }

  completeReport(row: any) {
    this.$router.push("/proyecto/report/complete/" + row.id);
  }
}
